// Handle Back in Stock button clicks for product cards
document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (event) {
    const backInStockButton = event.target.closest(".card__backinstock a");

    if (backInStockButton) {
      event.preventDefault();

      const cardInformation = backInStockButton.closest(".card__information");
      if (!cardInformation) return;

      const klaviyoTrigger = cardInformation.querySelector(
        ".klaviyo-bis-trigger",
      );
      if (klaviyoTrigger) {
        klaviyoTrigger.click();
      }
    }
  });
});
